import axios from 'axios'
import store from './store'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

if (!localStorage.getItem('accessToken')) {
  store.commit('authenticated', false)
  axios.defaults.headers.common.Authorization = ''
} else {
  console.log('WE HAVE AN ACCESSTOKEN')
  store.commit('authenticated', true)
  axios.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem('accessToken')
}

axios.interceptors.request.use(function (config) {
  store.commit('addAxiosInstance')
  return config
}, function (error) {
  return error
})

axios.interceptors.response.use(function (response) {
  store.commit('removeAxiosInstance')

  if (response.data['@Messages'] && response.data['@Messages'].length) {
    // backend did send some errors in response
    response.data['@Messages'].forEach(function (message) {
      store.commit('addMessage', { text: message, type: 'is-primary', hasIcon: true })
    })
  }
  if (response.data['@Warnings'] && response.data['@Warnings'].length) {
    // backend did send some errors in response
    response.data['@Warnings'].forEach(function (message) {
      store.commit('addMessage', { text: message, type: 'is-warning', hasIcon: true })
    })
  }
  if (response.data['@Errors'] && response.data['@Errors'].length) {
    // backend did send some errors in response
    response.data['@Errors'].forEach(function (message) {
      store.commit('addMessage', { text: message, type: 'is-danger', hasIcon: true })
    })
  }
  return response
}, function (error) {
  if (error.response.data['@Errors'] && error.response.data['@Errors'].length) {
    // backend did send some errors in response
    error.response.data['@Errors'].forEach(function (message) {
      store.commit('addMessage', { text: message, type: 'is-danger', hasIcon: true })
    })
  } else {
    // console.log(error.response.data)
    if (error.response && error.response.status === 401) {
      console.log('STILL GOT HERE')
      // something wrong with authorization
      localStorage.removeItem('accessToken')
      store.commit('authenticated', false)
    }
  }
  store.commit('removeAxiosInstance')
  return Promise.reject(error)
})

export default axios
